/* TÖSTI: ambassadør-bios som runde knapper pr. overskrift. Klik folder teksten ud under knappen; vælges en ny knap, foldes den forrige ind igen (kun én åben ad gangen pr. ambassadør). Kører kun på ambassadør-siden. */
(function(){
  'use strict';
  function stripEdge(html){
    var s = html;
    for(var i = 0; i < 30; i++){
      var next = s.replace(/^(?:\s|&nbsp;|<br\s*\/?>)+/i, '').replace(/(?:\s|&nbsp;|<br\s*\/?>)+$/i, '');
      if(next === s) break;
      s = next;
    }
    return s.trim();
  }
  function cleanLabel(html){
    var s = html.replace(/<br\s*\/?>/gi, ' ').replace(/&nbsp;/g, ' ');
    s = s.replace(/\s+/g, ' ').trim();
    s = s.replace(/:\s*$/, '');
    return s;
  }
  function parseFields(html){
    var re = /<strong[^>]*>([\s\S]*?)<\/strong>([\s\S]*?)(?=<strong[^>]*>|$)/gi;
    var fields = [], m;
    while((m = re.exec(html))){
      var label = cleanLabel(m[1]);
      var body = stripEdge(m[2]);
      if(label) fields.push({label: label, body: body});
    }
    return fields;
  }
  function setupBlock(g){
    var content = g.querySelector('.image-with-text--content.rte');
    var h2 = g.querySelector('h2');
    if(!content || !h2) return;
    /* Bioerne er skrevet forskelligt: nogle ligger i ét <p>, andre er delt i flere <p>-afsnit.
       Vi samler ALLE afsnit før vi leder efter <strong>-overskrifter, så intet indhold mistes. */
    var ps = content.querySelectorAll('p');
    if(!ps.length) return;
    var raw = Array.prototype.map.call(ps, function(x){ return x.innerHTML; }).join('');
    var fields = parseFields(raw);
    if(!fields.length) return;
    g.__tostiAcc2 = 1;
    var teaser = fields.shift();
    var out = '';
    if(teaser && teaser.body) out += '<p class="tosti-acc2__teaser"><strong>' + teaser.label + ':</strong> ' + teaser.body + '</p>';
    out += '<div class="tosti-acc2">';
    for(var k = 0; k < fields.length; k++){
      out += '<div class="tosti-acc2__item">' +
        '<button type="button" class="tosti-acc2__btn" aria-expanded="false">' + fields[k].label + '</button>' +
        '<div class="tosti-acc2__panel" hidden><p>' + fields[k].body + '</p></div>' +
        '</div>';
    }
    out += '</div>';
    content.innerHTML = out;
    var items = content.querySelectorAll('.tosti-acc2__item');
    items.forEach(function(item){
      var btn = item.querySelector('.tosti-acc2__btn');
      var panel = item.querySelector('.tosti-acc2__panel');
      btn.addEventListener('click', function(){
        var wasOpen = item.classList.contains('is-open');
        items.forEach(function(it){
          it.classList.remove('is-open');
          it.querySelector('.tosti-acc2__btn').setAttribute('aria-expanded', 'false');
          it.querySelector('.tosti-acc2__panel').hidden = true;
        });
        if(!wasOpen){
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });
  }
  function build(){
    if(!document.body.classList.contains('page-ambassadoerer')) return;
    var blocks = document.querySelectorAll('.featured-content .grid');
    blocks.forEach(function(g){
      if(g.__tostiAcc2) return;
      setupBlock(g);
    });
  }
  var n = 0, iv = setInterval(function(){ build(); if(++n > 60) clearInterval(iv); }, 250);
  document.addEventListener('DOMContentLoaded', build);
  window.addEventListener('load', build);
})();
